





import { Component, Vue } from 'vue-property-decorator'
import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community'
import { t } from 'element-ui/lib/locale'

@Component
export default class CmpMdScriptProcessorTargetModelCellRenderer extends Vue implements ICellRendererComp {
  private params!:ICellRendererParams
  private mValue: string

  created() {
    this.refresh(this.params)
  }

  getGui(): HTMLElement {
    return document.createElement('div')
  }

  refresh(params: ICellRendererParams): boolean {
    this.mValue = t('model.' + params.value)
    return true
  }
}
